var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1518",
    "data-name": "Groupe 1518",
    transform: "translate(-676 -2149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_35",
    className: "icon-stroke icon-needfill",
    "data-name": "Ellipse 35",
    transform: "translate(676 2149)",
    fill: "none",
    stroke: "#ba9857",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1517",
    "data-name": "Groupe 1517",
    transform: "translate(-466 -2015)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_319",
    className: "icon-stroke",
    "data-name": "Ligne 319",
    y2: 18,
    transform: "translate(1159 4172)",
    fill: "none",
    stroke: "#ba9857",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_320",
    className: "icon-stroke",
    "data-name": "Ligne 320",
    y2: 18,
    transform: "translate(1168 4181) rotate(90)",
    fill: "none",
    stroke: "#ba9857",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.be6fd039e78d018d7a48cabb0aae64c6.svg";
export { ForwardRef as ReactComponent };